import core from './core.html';

appConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$httpProvider', 'ngAuthSettings', '$ocLazyLoadProvider'];

function appConfig($stateProvider, $urlRouterProvider,$httpProvider, ngAuthSettings, $ocLazyLoadProvider){
  $httpProvider.interceptors.push('AuthInterceptor');
  
  $ocLazyLoadProvider.config({debug: true});
  // $urlRouterProvider.otherwise('/app/login');
  $urlRouterProvider.otherwise(($injector, $location) => {
    if($location.path()) return '/app/404';
    else return ngAuthSettings.config.home_url;
    
  });
  
  $stateProvider
    .state('home', {
      url: "/app",
      // abstract: true,
      template: core,
      controller : 'SharedController',
      controllerAs : 'shCtrl',
      resolve:{
        userData : userData
      }
    })
    .state('home.account', {
      url: "/mi-cuenta",
      template: `<account sh-ctrl="shCtrl"></account>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./account/account');
              $ocLazyLoad.load({name: 'app.account'});
              resolve(ctrl);
            })
          });
        }]
      }
    })
    .state('home.confirmationOrder', {
      url: "/confirmationOrder/{orderId}/{resolve}",
      template: `<confirmation-order sh-ctrl="shCtrl"></confirmation-order>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./confirmation-order/confirmation-order');
              $ocLazyLoad.load({name: 'app.confirmationOrder'});
              resolve(ctrl);
            })
          });
        }]
      }
    })
    .state('home.contact', {
      url: "/contact",
      template: `<contact sh-ctrl="shCtrl"></contact>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./contact/contact');
              $ocLazyLoad.load({name: 'app.contact'});
              resolve(ctrl);
            })
          });
        }]
      }
    })
    .state('home.dashboard', {
      url: "/panel-de-control",
      template: `<dashboard sh-ctrl="shCtrl"></dashboard>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./dashboard/dashboard');
              $ocLazyLoad.load({name: 'app.dashboard'});
              resolve(ctrl);
            })
          });
        }]
      }
    })
    .state('home.knowUs', {
      url: "/conocenos",
      template: `<know-us sh-ctrl="shCtrl"></know-us>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./know-us/know-us');
              $ocLazyLoad.load({name: 'app.knowUs'});
              resolve(ctrl);
            })
          });
        }]
      }
    })
    .state('home.register', {
      url: "/register",
      template: `<register sh-ctrl="shCtrl"></register>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./register/register');
              $ocLazyLoad.load({name: 'app.register'});
              resolve(ctrl);
            })
          });
        }]
      }
    })
    .state('home.users', {
      url: "/users",
      template: `<users sh-ctrl="shCtrl"></users>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./users/users');
              $ocLazyLoad.load({name: 'app.users'});
              resolve(ctrl);
            })
          });
        }]
      }
    })
    .state('home.salesHome', {
      url: "/sales-home",
      template: `<sales-home sh-ctrl="shCtrl"></sales-home>`,
      resolve:{
        loadController : ['$q','$ocLazyLoad', ($q,$ocLazyLoad) => {
          return $q((resolve) => {
            require.ensure([], () => {
              let ctrl = require('./sales-home/sales-home');
              $ocLazyLoad.load({name: 'app.salesHome'});
              resolve(ctrl);
            })
          });
        }]
      }
    });
  
  userData.$inject = ['SessionService', '$state', 'CartService', 'SharedService'];
  function userData(SessionService, $state, CartService, SharedService){
    let userData = {};
    let cartId = SessionService.get('cartId') || '';
    let userId = '';
    let clientPriceListName = '';
    try {
      clientPriceListName = SessionService.get('quoteCartSeller').clientPriceList;
    } catch(e) {}
    return SessionService.getGlobals().then(globals => {
      userData.globals = globals;
      try{ userId = userData.globals.currentUser.userId; }
      catch(e){}
      return CartService.getCart(cartId, userId, clientPriceListName).then(cartInfo => {
        userData.cartInfo = cartInfo;
        return SharedService.getInitialParams(userId).then(data => {
          userData.globalCategories = data[0].data;
          userData.categoriesMenu = data[1].data;
          userData.banners = data[2].data;
          userData.params = data[3].data;
			if(userData.params.showChat) {
					// Esta funcion se encuentra en el archivo assets/lib/chat.js
					cargarChat();
					
			}
          return userData;
        }).catch(error => {
          console.log(error);
          return {};
        });
      })
    }).catch(reason => {
      $state.go('login');
    });
  }
  
  
}

export default appConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/app.config.js
 **/